// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"8":"3e5e07a679f72c0e518e","642":"5f0f7fc9fb02f36d6873"}[chunkId] + ".bundle.js";
};